export default "__VITE_ASSET__mJFAjo1a__"